import axios from "axios";
import Config from "src/config";

const v2_actionDeletarSetor = (setorId, data) => {
    return axios({
        method: "delete",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/${setorId}/setores/deletar`,
        data
    });
};

export default v2_actionDeletarSetor;
